import { Component, computed, contentChildren, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SafeHtml } from '@angular/platform-browser';
import { PageActionDirective } from 'src/app/shared/directives/page-action.directive';
import { PassDataService } from 'src/app/shared/services/pass-data/pass-data.service';
import { PlatformService } from 'src/app/shared/services/platform.service';

@Component({
  selector: 'urban-page-actions',
  templateUrl: './page-actions.component.html',
  host: {
    class: 'uvActions'
  },
  standalone: false
})
export class PageActionsComponent {
  protected readonly isMobile = inject(PlatformService).isMobileViewport;
  protected readonly icons = toSignal(inject(PassDataService).sanIcons$, { initialValue: {} as Record<string, SafeHtml> });
  protected readonly actions = contentChildren(PageActionDirective, { descendants: true });
  // A name the icon set has no SVG for would draw an empty button.
  protected readonly single = computed<PageActionDirective | null>(() => {
    const actions: readonly PageActionDirective[] = this.actions();
    const icon: string = actions.length === 1 ? actions[0].icon() : '';

    return icon && this.icons()[icon] ? actions[0] : null;
  });
}
